import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Layout, Button, Badge, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { MailOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.css";
import LayoutHeader from "./layout_header";
import { useDispatch, useSelector } from "react-redux";
import {
  snapCountRequestByOwner,
  unSnapCountReq,
} from "../../../store/request/request.action";
import { countSelector } from "../../../store/request/request.selector";

const LayoutRoot = () => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const params = useParams();
  const language = params?.language || "en";
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const count = useSelector(countSelector);
  // console.log({ count });
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapCountRequestByOwner());
    return () => dispatch(unSnapCountReq());
  }, [dispatch]);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="layout main root">
      <LayoutHeader />
      <Outlet />
      {/* {renderMailAlert()} */}
    </Layout>
  );
};

export default LayoutRoot;
